import React from "react";
import { makeStyles} from '@mui/styles';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import { Transition, TransitionGroup } from 'react-transition-group';
import Navbar from "./components/Navbar";
import Home from "./contents/Home";
import Projects from "./contents/Projects";
import Resume from "./contents/Resume";
import Grid from "@mui/material/Grid";
import ScrollToProject from "./components/ScrollToProject"
import { play, exit } from './timelines'
import "./App.css";
import {globalTheme} from "./components/Theme"
import { useRef } from "react";
import ScrollToTopButton from "./components/ScrollToTopButton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    //backgroundColor: "rgb(255, 255, 255)"
    backgroundColor: "rgba(23, 26, 33, 1)"
  },
  fade: {
    opacity: 1
  },
  grid: {
    minHeight: "100vh",
  },
}));


function App() {
  const classes = useStyles(globalTheme);
  const nodeRef = useRef(null)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={globalTheme}>
        <div className={classes.root}>
          <Router>
            <ScrollToProject/>
            <ScrollToTopButton />
            <Grid 
              container
              direction="column"
              className={classes.grid}
            >
              <Grid item style={{backgroundColor: "rgba(23, 26, 33, 1)"}}>
                <Navbar />
              </Grid>  

                {/* Route for Home.js contents */}

                <Grid item className={classes.content}>

                  <Route render={( {location} ) => {
                    const { pathname, key } = location

                    return(
                      <TransitionGroup component={null}>
                        <Transition
                            nodeRef={nodeRef}
                            key={key}
                            appear={true}
                            // onEnter={(node, appears) => play(pathname, node, appears)}
                            // onExit={(node, appears) => exit(node, appears)}
                            onEnter={(_, appears) => play(pathname, nodeRef.current, appears)}
                            onExit={(_, appears) => exit(nodeRef.current, appears)}
                            timeout={{enter: 750, exit: 150}}
                          >
                          <div ref={nodeRef} style={{backgroundColor: "rgba(23, 26, 33, 1)", minHeight: "100vh",}}>
                            <Switch location={location}> 
                              <Route exact path="/">
                                <Home />
                              </Route>

                              {/* Route for Projects.js contents */}
                              <Route path="/projects">
                                <Projects />
                              </Route>

                              {/* Route for Resume.js contents */}
                              <Route path="/resume">
                                <Resume />
                              </Route>
                            </Switch>
                          </div>
                          </Transition>
                      </TransitionGroup>
                    )
                  }}/>
                </Grid>
            </Grid>
          </Router>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
